export default __webpack_public_path__ + "static/media/inter-v2-latin-regular.4593a4cb.svg";